import { render, staticRenderFns } from "./ViewResource.vue?vue&type=template&id=0e186baa&"
import script from "./ViewResource.vue?vue&type=script&lang=ts&"
export * from "./ViewResource.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports